import React, { useEffect, useRef, useState } from 'react';
import * as Styled from './MemberGetMember.styles';
import { MdContentCopy, MdArrowForward } from 'react-icons/md';
import {
  getClickedLinksService,
  getGeneratedLinkService,
  getWalletService,
} from '@services/member-get-member';
import InfiniteScroll from 'react-infinite-scroll-component';
import SpinningWheel from '../SpinningWheel/SpinningWheel';
import { format } from 'date-fns';
import { useCurrentLang } from '@utils/translate';
import { enUS, es, ptBR } from 'date-fns/locale';
import { translate as t } from '@utils/translate';
import { useSelector } from 'react-redux';

const langs = {
  pt_BR: ptBR,
  en_US: enUS,
  es_ES: es,
};

const MemberGetMember = () => {
  const [hide, setHide] = useState(true);
  const [wallet, setWallet] = useState({ data: [], total: 0 });
  const [campaignData, setCampaignData] = useState({});
  const [finishedPagination, setFinishedPagination] = useState(false);
  const [link, setLink] = useState(null);
  const [copied, setCopied] = useState(false);
  const currency = useSelector(state => state.general.currency);
  const language = useCurrentLang();

  const localizedTermAndConditionLink = {
    pt_BR:
      'https://flyflapper.com/stories/pt-br/conheca-o-programa-de-indicacoes-flapper',
    en_US:
      'https://flyflapper.com/stories/discover-the-flapper-referral-program',
    es_ES:
      'https://flyflapper.com/stories/es/descubra-el-programa-de-recomendacion-flapper',
  };

  const TEXTS = {
    TITLE: t('mgmInviteYourFriends'),
    SUBTITLE: t('mgmShareFunWithFriends'),
    READ_TERMS_AND_CONDITIONS: t('readTermsAndConditions'),
    SHARE_YOUR_LINK: t('shareYourLink'),
    SIGNUPS: t('signups'),
    PURCHASES: t('purchases'),
    EARNED: t('earned'),
    YOUR_BALANCE: t('yourBalance'),
    COPIED: t('copied'),
    SHOW_DETAILS: t('showDetails'),
    HIDE_DETAILS: t('hideDetails'),
    WALLET_EMPTY: t('yourWalletIsEmpty'),
    PENDING: t('pending'),
    REVOKED: t('revoked'),
    AVAILABLE: t('available'),
    USED: t('USED'),
    CONSUME_PARTIAL: t('consumePartial'),
    VALID_THRU: t('validThru'),
    EXPIRED: t('expired'),
  };

  const getWallet = async ({ currencyChange } = { currencyChange: false }) => {
    const page =
      wallet?.pagination?.page && !currencyChange
        ? wallet.pagination.page + 1
        : 1;
    try {
      const response = await getWalletService({
        params: { page, limit: 5, currency: currency?.code },
      });

      if (response?.data?.wallet?.length) {
        setWallet(
          {
            data: currencyChange
              ? [...response?.data?.wallet]
              : [...wallet?.data, ...response?.data?.wallet],
            total: response?.data?.totalBalance || 0,
            pagination: {
              limit: response?.data?.limit,
              totalItems: response?.data?.totalItems,
              totalPages: response?.data?.totalPages,
              page: page,
            },
          } || null
        );
      } else {
        setFinishedPagination(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getClickedLinks = async () => {
    try {
      const response = await getClickedLinksService();
      setCampaignData(response?.data?.memberGetMember);
    } catch (error) {
      console.error(error);
    }
  };

  const generateLink = async () => {
    try {
      const response = await getGeneratedLinkService();
      setLink(response.data?.memberGetMember?.link);
    } catch (error) {
      console.error(error);
    }
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  useEffect(() => {
    (async () => {
      getClickedLinks();
      generateLink();
    })();
  }, []);

  useEffect(() => {
    setWallet({ data: [], total: 0 });
    setFinishedPagination(false);
    getWallet({ currencyChange: true });
  }, [currency]);

  return (
    <Styled.MainContainer>
      <Styled.FirstSection>
        <Styled.Title className="margin-top-28 margin-bottom-16">
          {TEXTS.TITLE}
        </Styled.Title>
        <Styled.Text className="margin-bottom-16">{TEXTS.SUBTITLE}</Styled.Text>
        <Styled.Link href={localizedTermAndConditionLink[language]}>
          {TEXTS.READ_TERMS_AND_CONDITIONS}
        </Styled.Link>
        <Styled.Subtitle className="margin-top-40">
          {TEXTS.SHARE_YOUR_LINK}
        </Styled.Subtitle>
        <Styled.ShortLink className="margin-top-18 margin-bottom-12">
          <Styled.SmallSubtitle>{link}</Styled.SmallSubtitle>
          {copied ? (
            <Styled.Copied>
              {language === 'es_ES' ? `¡${TEXTS.COPIED}` : TEXTS.COPIED}!
            </Styled.Copied>
          ) : (
            <MdContentCopy onClick={copyLink} className="cursor-pointer" />
          )}
        </Styled.ShortLink>
        <Styled.Data>
          <Styled.Column>
            <Styled.SmallSubtitle>
              {campaignData?.hitCount || 0}
            </Styled.SmallSubtitle>
            <Styled.SmallText>Clicks</Styled.SmallText>
          </Styled.Column>
          <Styled.Column>
            <Styled.SmallSubtitle>
              {campaignData?.acceptedInvitations?.length || 0}
            </Styled.SmallSubtitle>
            <Styled.SmallText>{TEXTS.SIGNUPS}</Styled.SmallText>
          </Styled.Column>
          {/* <Styled.Column>
            <Styled.SmallSubtitle>2</Styled.SmallSubtitle>
            <Styled.SmallText>{TEXTS.PURCHASES}</Styled.SmallText>
          </Styled.Column> */}
          {/* <Styled.Column>
            <Styled.SmallSubtitle>2.000 {currency?.code}</Styled.SmallSubtitle>
            <Styled.SmallText>{TEXTS.EARNED}</Styled.SmallText>
          </Styled.Column> */}
        </Styled.Data>
      </Styled.FirstSection>
      <Styled.SecondSection>
        <Styled.Balance className="margin-top-48 md-margin-top-28">
          <Styled.Column>
            <Styled.Subtitle className="margin-bottom-4">
              {TEXTS.YOUR_BALANCE}
            </Styled.Subtitle>
          </Styled.Column>
          <Styled.Column>
            <Styled.Title className="margin-bottom-4 text-end">
              {wallet.total?.toFixed(2)} {currency?.code}
            </Styled.Title>
            <Styled.ButtonLink
              href="#"
              onClick={() => setHide(!hide)}
              className="text-end"
            >
              {hide ? TEXTS.SHOW_DETAILS : TEXTS.HIDE_DETAILS}
            </Styled.ButtonLink>
          </Styled.Column>
        </Styled.Balance>

        <Styled.Flights hide={hide} id="scroll">
          <InfiniteScroll
            dataLength={wallet?.data?.length || 0}
            next={getWallet}
            hasMore={!finishedPagination}
            loader={
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <SpinningWheel />
              </div>
            }
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 20,
              overflow: 'hidden',
            }}
            scrollableTarget={'scroll'}
          >
            {!wallet?.data?.length && finishedPagination && TEXTS.WALLET_EMPTY}

            {wallet?.data?.map((info, index) => (
              <Styled.Flight key={index}>
                <Styled.Column>
                  <Styled.FlightDate>
                    {TEXTS.VALID_THRU}{' '}
                    {format(new Date(info?.expiryDatetime), 'PPpp', {
                      locale: langs[language],
                    })}
                  </Styled.FlightDate>
                  <Styled.FlightRoute>{info?.description}</Styled.FlightRoute>
                </Styled.Column>
                <Styled.Subtitle style={{ flexShrink: 0, textAlign: 'end' }}>
                  {info?.amount?.toFixed(2)} {info?.currency}
                  <Styled.Status type={info?.status}>
                    {TEXTS[info?.status?.replace('-', '_').toUpperCase()] ??
                      'N/D'}
                  </Styled.Status>
                </Styled.Subtitle>
              </Styled.Flight>
            ))}
          </InfiniteScroll>
        </Styled.Flights>
      </Styled.SecondSection>
    </Styled.MainContainer>
  );
};

export default MemberGetMember;
